<template>
  <z-tooltip
    v-if="tooltip"
    :top="
      tooltipPosition !== 'left' &&
      tooltipPosition !== 'right' &&
      tooltipPosition !== 'bottom' &&
      tooltipPosition === 'top'
    "
    :left="tooltipPosition === 'left'"
    :bottom="tooltipPosition === 'bottom'"
    :right="tooltipPosition === 'right'"
    v-bind="$attrs"
  >
    <template v-slot:activator="{on}">
      <span v-on="on">
        <v-icon
          class="zoox-component zoox-icon"
          :size="size"
          :color="color"
          :dark="dark"
          :dense="dense"
          :disabled="disabled"
          :large="large"
          :small="small"
          :x-large="xLarge"
          :x-small="xSmall"
          v-on="$listeners"
        >
          <!--@slot slot default do componente -->
          <slot></slot>
        </v-icon>
      </span>
    </template>
    <span>{{ tooltip }}</span>
  </z-tooltip>

  <v-icon
    v-else
    class="zoox-component zoox-icon"
    :size="size"
    :color="color"
    :dark="dark"
    :dense="dense"
    :disabled="disabled"
    :large="large"
    :small="small"
    :x-large="xLarge"
    :x-small="xSmall"
    v-on="$listeners"
  >
    <!--@slot slot default do componente -->
    <slot></slot>
  </v-icon>
</template>

<script>
/**
 * @displayName Icon
 */
export default {
  name: 'ZIcon',
  props: {
    /**
     * Cor do ícone exibido
     */
    color: {
      type: String,
      required: false,
    },
    /**
     * Flag para indicar que a cor é escura e deve usar texto branco
     */
    dark: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para utilizar a variação dense (menor)
     */
    dense: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para indicar que deve estar desabilitado
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para indicar que deve usar a variação grande
     */
    large: {
      type: Boolean,
      default: false,
    },
    /**
     * Tamanho para ser utilizado (em px)
     */
    size: {
      type: [Number, String],
      default: undefined,
    },
    /**
     * Flag para indicar que deve usar a variação pequena
     */
    small: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para indicar que deve usar a variação extra pequena
     */
    xSmall: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para indicar que deve usar a variação extra grande
     */
    xLarge: {
      type: Boolean,
      default: false,
    },
    /**
     * Define texto para ser aplicado ao tooltip do icone
     */
    tooltip: {
      type: String,
      required: false,
    },
    /**
     * Define a posição do tooltip do icone
     *
     * @values top, left, bottom, right
     **/

    tooltipPosition: {
      type: String,
      required: false,
      default: 'top',
    },
  },
}
</script>
